import * as urlWebservice from "utils/apis"
import * as actionsWebservice from "utils/functions/httpMethods"

// Find the lastest notification
export const findLastestNotification = async () => {
  try {
    const results = await actionsWebservice.get(urlWebservice.FIND_LASTEST_NOTIFICATION)
    return results
  } catch (error) {
    throw new Error(error)
  }
}

// Find the lastest notification
export const updateSeen = async (notificationId) => {
  try {
    const results = await actionsWebservice.update(`${urlWebservice.UPDATE_SEEN_NOTIFICATION}/${notificationId}`)
    return results
  } catch (error) {
    throw new Error(error)
  }
}
